import { ColorPalette } from '@wordpress/components';
import withColorContext from './with-color-context';

export default withColorContext( ColorPalette );
